import * as React from 'react';
import { useContext } from 'react';
import { FileProps, imageFileComponent } from '../../../../shared/DragAndDrop';
import { formatSizeUnits } from '../../../../../utils';
import { useTranslate } from 'sbx-crm-menu-ui';
import { AppAgentContext } from '../../../../../context/ContextProvider';
import { DragAndDropV2 } from '../../../../shared/DragAndDropV2';
import { X } from 'lucide-react';
import { appActions } from 'src/store';
import { ModalType } from 'src/types/Modal';
import ExcelPreview from 'src/components/shared/ExcelFilePreview';
import { EnumSkillRetrieverFields } from 'src/types/Common';

type Props = {
    setFiles: (files: File[]) => void
    files: File[]
    filesComponent: FileProps[]
    setFilesComponent: (files: FileProps[]) => void
    deleteFile: (file: FileProps) => void
    typeExcelOnly?: boolean,
    onchange?: (field: EnumSkillRetrieverFields) => void
};
const SkillFileComponent = ({ setFilesComponent, setFiles, filesComponent, files, deleteFile, typeExcelOnly, onchange }: Props) => {

    const {
        state: {
            session: {
                ai_agent_config:
                    { file_types = ['pdf'] },
            },
        },
    } = useContext(AppAgentContext);

    const { dispatch } = React.useContext(AppAgentContext);
    

    const { t: common } = useTranslate('common');
    const { t: agent } = useTranslate('agent');

    const preview = (file:File) =>{

        dispatch(appActions.openModal({
            type: ModalType.DYNAMIC,
            data: {
                title: file.name,
                className: 'max-w-[95%]',
                onClose: () => dispatch(appActions.closeModal(ModalType.DYNAMIC)),
                children: () => {
                    return (
                       <ExcelPreview file={file} />
                    )
                }
            }
        }))

    }

    return (
        <div>
            <div className="grid gap-1 items-center mb-3">
                <label htmlFor="" className={`${typeExcelOnly && files.length !== 0 ? "hidden":""} form-input-label`}>{common('upload_file')}</label>
                <DragAndDropV2
                    fileTypes={typeExcelOnly ? ['csv', 'xlsx'] : file_types}
                    files={files}
                    filesComponent={filesComponent}
                    setFiles={setFiles}
                    setFilesComponent={setFilesComponent}
                    onchange={onchange}
                />
            </div>
            {filesComponent.length > 0 && <div className="grid gap-1 items-center mb-5">
                <h2 className="form-input-label">{common('files')}</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 ">
                    {(filesComponent).map((file, index) => (
                        <div key={index}
                             className="bg-white rounded-lg shadow border border-purple-200 p-3 flex flex-col">
                            <div className="flex gap-2 justify-between">


                                <div 
                                    className={`flex gap-2${typeExcelOnly ? ' cursor-pointer' : ''}`}
                                    title={`${typeExcelOnly ? agent('preview_excel') : ''}`} 
                                    onClick={() => typeExcelOnly && preview(files[index])}
                                >
                                    <div>
                                        {imageFileComponent(file)}
                                    </div>
                                    <div>
                                        <p className="text-sm font-medium text-purple-700
                                    text-left hover:text-purple-900 transition-colors duration-300 ease-in-out">{file.name}</p>
                                        <span className="text-xs text-gray-500 mt-1">
                                        {formatSizeUnits(file.size)}</span>
                                    </div>

                                </div>

                                <div>

                                    <button
                                        onClick={() => deleteFile(file)}
                                        className="text-pink-500 hover:text-pink-700 transition-colors duration-300 ease-in-out"
                                    >
                                        <X className="h-5 w-5" />
                                    </button>
                                </div>
                            </div>


                        </div>
                    ))}
                    {
                        (filesComponent).length === 0 && (
                            <p className="text-gray-300">
                                {common('no_files')}
                            </p>
                        )
                    }
                </div>
            </div>}
        </div>
    );
};

export default SkillFileComponent;